function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-32.999 -1080.711)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(33 1100.711)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33 1090.549)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001 0.162)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33 1080.386)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001 0.324)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(43 1100.711)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(43 1090.549)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001 0.162)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(43 1080.386)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001 0.324)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53 1100.711)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53 1090.549)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001 0.162)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53 1080.386)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001 0.324)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5,6.5H1C0.2,6.5-0.5,5.8-0.5,5V1c0-0.8,0.7-1.5,1.5-1.5h4c0.8,0,1.5,0.7,1.5,1.5v4C6.5,5.8,5.8,6.5,5,6.5z  M1,0.5C0.7,0.5,0.5,0.7,0.5,1v4c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5V1c0-0.3-0.2-0.5-0.5-0.5H1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,5.5h-5v-5h5V5.5z M1.5,4.5h3v-3h-3V4.5z"
})))));

var SvgAppsSelectIcon = function SvgAppsSelectIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppsSelectIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apps-select-icon.5efbc623.svg";
export { ForwardRef as ReactComponent };